<script>
import { DATE_RANGE_OPTIONS } from '../../constants';

const EVENT_NAME = 'on-range-change';
const DATE_RANGE_LABELS = {
  TODAY: 'Hoje',
  LAST_7_DAYS: 'Últimos 7 dias',
  LAST_30_DAYS: 'Últimos 30 dias',
  LAST_3_MONTHS: 'Últimos 3 meses',
  LAST_6_MONTHS: 'Últimos 6 meses',
  LAST_YEAR: 'Último ano',
  CUSTOM_DATE_RANGE: 'Intervalo de datas personalizado',
};

export default {
  name: 'ReportFiltersDateRange',
  props: {
    defaultDateRange: {
      type: String,
      default: DATE_RANGE_OPTIONS.TODAY.id,
    },
  },
  data() {
    const translatedOptions = Object.values(DATE_RANGE_OPTIONS).map(option => ({
      ...option,
      name: DATE_RANGE_LABELS[option.id] || this.$t(option.translationKey),
    }));

    return {
      // relies on translations, need to move it to constants
      selectedOption: translatedOptions.find(
        option => option.id === this.defaultDateRange
      ),
      options: translatedOptions,
    };
  },
  methods: {
    updateRange(selectedRange) {
      this.selectedOption = selectedRange;
      this.$emit(EVENT_NAME, selectedRange);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      track-by="name"
      label="name"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :options="options"
      :searchable="false"
      :allow-empty="false"
      @select="updateRange"
    />
  </div>
</template>
